import {decimalsMultiplier} from '#/utils/contract-consts';

export const getEstimatedPricePerToken = (landTokenAmount: number, stableTokenAmount: number): number =>
  landTokenAmount === 0 || stableTokenAmount === 0 ? 0 : (stableTokenAmount / landTokenAmount) * decimalsMultiplier;
